<script>
    import { fly } from "svelte/transition";
    import { goToNextStep } from "./quiz-controller.svelte";
    import store from "./quiz-store";

    export let visible;
    export let body;
    export let waitUntilCanProceed;

    let container;
    let canProceed = false;
    let nextButtonOverlayContainer;

    function startNextButtonTransition() {
        nextButtonOverlayContainer.style.marginLeft = "100%";
        nextButtonOverlayContainer.classList.add("shadow-xl");
    }
</script>

{#if visible}
    <div
        class="flex size-full flex-1 flex-col items-center justify-around gap-4 py-6"
        bind:this={container}
        transition:fly={{ y: 48, delay: 350 }}
        on:introend={startNextButtonTransition}
    >
        <div class="w-full flex-1 overflow-scroll text-center text-lg">
            {@html body}
        </div>
        <button
            on:click={goToNextStep}
            disabled={!canProceed}
            class="
        relative overflow-hidden rounded px-4 py-2 text-xl font-medium
        transition-all duration-200
      "
            class:hover:scale-105={canProceed}
            class:hover:shadow-xl={canProceed}
        >
            Next
            <div
                bind:this={nextButtonOverlayContainer}
                class="
            next-button-overlay
            absolute inset-0 ml-0 bg-white
            opacity-65 transition-[margin-left,shadow] ease-linear
        "
                style="--wait-duration: {waitUntilCanProceed}s;"
                on:transitionend={() => {
                    canProceed = true;
                }}
            ></div>
        </button>
    </div>
{/if}

<style>
    button {
        background-color: var(--primary-color);
        color: var(--text-on-primary-color);
    }

    .next-button-overlay {
        transition-duration: var(--wait-duration);
    }
</style>
